// src/api/auth.js

import client from './client';
import {
  setCredentials,
  clearCredentials,
  getUserId,
  getAuthCode
} from './authStorage';

/**
 * Logs in and immediately validates the admin.
 */
export async function login(usernameOrEmail, password) {
  const { data: loginRes } = await client.post('/admin_login.php', {
    username_or_email: usernameOrEmail,
    password
  });

  if (loginRes.status !== 200) {
    throw new Error(loginRes.message);
  }

  const { user_id, auth_code, roles } = loginRes;
  setCredentials(auth_code, user_id, roles);

  const { data: validateRes } = await client.post('/validate_admin.php', {
    user_id,
    auth_code
  });

  if (validateRes.status !== 200) {
    clearCredentials();
    throw new Error(validateRes.message);
  }

  return {
    userId:   user_id,
    authCode: auth_code,
    roles,
    user:     validateRes.data
  };
}

/**
 * Calls logout.php on the server, then clears local credentials.
 */
export async function logout() {
  const user_id   = getUserId();
  const auth_code = getAuthCode();

  try {
    const { data } = await client.post('/logout.php', { user_id, auth_code });
    if (data.status !== 200) {
      throw new Error(data.message);
    }
  } catch {
    // swallow any error from the API call
  } finally {
    clearCredentials();
  }
}

/**
 * Validates the current stored credentials,
 * returns the user object if valid.
 */
export async function validateAdmin() {
  const user_id   = getUserId();
  const auth_code = getAuthCode();

  const { data: res } = await client.post('/validate_admin.php', {
    user_id,
    auth_code
  });

  if (res.status !== 200) {
    clearCredentials();
    throw new Error(res.message);
  }

  return res.data;
}
